import Image from "next/image";
import ReactMarkdown from "react-markdown";
import { cn } from "@/lib/utils";

interface EventWelcomeBannerProps {
  eventName?: string | null;
  welcomeMessage?: string | null;
  logoUrl?: string | null;
  className?: string;
}

export function EventWelcomeBanner({
  eventName,
  welcomeMessage,
  logoUrl,
  className,
}: EventWelcomeBannerProps) {
  if (!eventName && !welcomeMessage) return null;

  return (
    <div className={cn("bg-[hsl(217,50%,21%)]/5 border-b px-4 py-3", className)}>
      <div className="flex items-center gap-4">
        {logoUrl && (
          <Image
            src={logoUrl}
            alt={eventName ?? "Event logo"}
            width={64}
            height={64}
            className="h-16 w-16 shrink-0 rounded-lg object-contain"
          />
        )}
        <div className="min-w-0">
          {eventName && (
            <h2 className="text-base font-semibold text-foreground">
              Welcome to {eventName}
            </h2>
          )}
          {welcomeMessage && (
            <div className="mt-0.5 text-sm text-muted-foreground [&>*:first-child]:mt-0 [&>*:last-child]:mb-0 [&_p]:my-1 [&_ul]:my-1 [&_ol]:my-1 [&_ul]:list-disc [&_ul]:pl-4 [&_ol]:list-decimal [&_ol]:pl-4 [&_strong]:font-semibold [&_em]:italic">
              <ReactMarkdown
                components={{
                  a: ({ children, ...props }) => (
                    <a {...props} target="_blank" rel="noopener noreferrer" className="text-primary underline">
                      {children}
                    </a>
                  ),
                }}
              >
                {welcomeMessage}
              </ReactMarkdown>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
